import axios from 'axios';
import { HOSTNAME } from './defaults';
import store from '../../store';

const baseURL = 'https://ecommerce-api.maliplus.co.ke/maliplusEcom/links/POS/'
// const baseURL = 'http://192.168.1.28:8080/Ecommerce-Service/links/POS/'

const instance = axios.create({
    baseURL,
    timeout: 120000,
    timeoutErrorMessage: 'The server timed out while performing a request.',
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'POST',
    },
    responseType: 'json'
});
// salamapharmaceuticals.com 

// const hostname = window.location.host.includes('localhost') ? 'sirgil.ke' : window.location.host;


const config = {
    source_type: 'WEB',
    hostname: HOSTNAME,
};

const cancelToken = axios.CancelToken;
const source = cancelToken.source();
const fetch = {};

fetch.get = (url, params = {}) => {
    const token = store.getState().user.user?.token;
    let obj = { ...config, ...params, token };
    let query = Object.keys(obj)
        .map((key) => key + '=' + obj[key])
        .join('&');
    return new Promise((resolve, reject) => {
        instance
            .post(url + '?' + query)
            .then(
                function (res) {
                    resolve(res.data);
                },
                function (err) {
                    reject('object' == typeof err ? err.message : err);
                }
            )
            .catch(function (err) {
                reject('object' == typeof err ? err.message : err);
            });
    });
};

fetch.post = (url, data) => {
    const token = store.getState().user.user?.token;
    return new Promise((resolve, reject) => {
        instance
            .post(url, { ...data, ...config, token })
            .then(
                function (res) {
                    resolve(res.data);
                },
                function (err) {
                    reject('object' == typeof err ? err.message : err);
                }
            )
            .catch(function (err) {
                reject('object' == typeof err ? err.message : err);
            });
    });
};

export const cancelRequest = source.cancel;
export default fetch;
